import axios from "axios";
import {
  destroyFile,
  getImageDimensionSizes,
  getMongoFileId,
  getThirdPartySystem,
  getTokenHeader,
  generateImageFromPdf
} from "@/helpers/commonHelper";
import { confirmWarningConfig } from "@/configuration/confirmConfigurations";
import "./NewsEditDialog.scss";
import CKEditor from "ckeditor4-vue";
import Login from "@/views/Login/Login.vue";
import {
  getDefaultContentTypes,
  getIssueById,
  isLocked,
  imports
} from "@/helpers/newsHelper";
import * as newsHelper from "@/helpers/newsHelper";
let newsHelperVar = { ...newsHelper };
delete newsHelperVar["imports"];
import * as newsGbXmlHelper from "@/helpers/newsGbXmlHelper";
import DateInput from "@/components/Common/DateInput/DateInput.vue";
import { v4 as uuid } from "uuid";
import NewsImagePreview from "@/components/News/NewsImagePreview/NewsImagePreview.vue";
import NewsFilePreview from "@/components/News/NewsFilePreview/NewsFilePreview.vue";
import { uploadFile } from "@/helpers/fileHelper";
import _ from "lodash";
import { getUserById } from "@/helpers/userHelper";
import ValidationDialog from "@/components/Common/ValidationDialog/ValidationDialog.vue";
import moment from "moment";
import NewsAppPushMessageEditDialog from "@/components/News/NewsAppPushMessageEditDialog/NewsAppPushMessageEditDialog.vue";
import NewsDetailViewCustomizerDialog from "@/components/News/NewsDetailViewCustomizerDialog/NewsDetailViewCustomizerDialog.vue";
import InfoDialog from "@/components/Common/InfoDialog/InfoDialog.vue";

const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export default {
  name: "NewsEditDialog",
  components: {
    InfoDialog,
    NewsAppPushMessageEditDialog,
    Login,
    ckeditor: CKEditor.component,
    DateInput,
    NewsImagePreview,
    NewsFilePreview,
    ValidationDialog,
    NewsDetailViewCustomizerDialog
  },
  data: () => ({
    customizeDialog: false,
    editorUrl: "https://cdn.eberl-online.cloud/ckeditor/ckeditor.js",
    needLogin: false,
    mainGreen: "#97bd0f",
    mainRed: "#c55c52",
    mainGray: "#7a7a7a",
    previewDialog: false,
    password: "",
    refreshKey: 1,
    isRequired: [v => !!v || "Dieses Feld darf nicht leer sein!"],
    logs: [],
    editedItem: {
      news_links: [{ title: "", url: "" }],
      meta_data: {
        externLinkNews: false
      },
      appdinx_channels: [],
      box_layout: false
    },
    issues: {},
    features: {},
    featureGroups: {},
    appContentTypes: [],
    acceptImageMimeType: `
      image/jpeg,
      image/tiff,
      image/png,
      image/vnd.adobe.photoshop,
      application/x-photoshop,
      application/photoshop,
      application/psd,
      image/psd,
      application/postscript,
      application/pdf`,
    imagesDragging: false,
    filesDragging: false,
    loading: false,
    viewLog: [],
    panel: 0,
    panels: [
      { title: "Nachricht Allgemein", key: 0 },
      { title: "Merkmale", key: 1 },
      { title: "Medien", key: 2 },
      { title: "Datum & Zeit", key: 3 },
      { title: "Push-Nachricht", key: 4 },
      { title: "Verknüpfungen & Metadaten", key: 5 },
      { title: "Bearbeitungsstatus", key: 6 }
    ],
    hidePanels: [],
    textTabs: null,
    printContentConfig: {
      allowedContent: "p;br;strong;b;i",
      toolbar: [
        {
          name: "clipboard",
          items: ["Cut", "Copy", "PasteFromWord", "-", "Undo", "Redo"]
        },
        { name: "editing", items: ["Find", "Replace"] },
        {
          name: "basicstyles",
          items: ["Bold", "Italic", "RemoveFormat"]
        }
      ],
      height: 400,
      removePlugins: "elementspath",
      removeFormatTags: "b,em,i,h4",
      // https://ckeditor.com/docs/ckeditor4/latest/api/CKEDITOR_config.html#cfg-enterMode
      // break lines with <br> instead of p-tags
      enterMode: 2,
      autoParagraph: false,
      on: {
        paste: evt => {
          // replace p-tag-wrapping with br-tag
          evt.data.dataValue = evt.data.dataValue
            .replace(/<p[^>]*>/gi, "")
            .replace(/<\/p>/gi, "<br/>");
        }
      }
    },
    debugXml: false,
    newsLoading: false,
    searchNews: "",
    creator: { first_name: "", last_name: "" },
    removeFileArray: [],
    errorList: [],
    errorDialog: false,
    createAppPushMessageDialog: false,
    existingAppPushMessage: null
  }),
  watch: {
    isAdmin(newState) {
      if (newState) {
        //add source option to ckeditor
        const source = {
          name: "extraGroup",
          items: ["-", "Source"]
        };
        this.webContentConfig?.toolbar.push(source);
        this.printContentConfig?.toolbar.push(source);
      }
    },
    isWebNews() {
      this.setPanelsForAppOrWebNews();
    },
    isAppNews() {
      this.setPanelsForAppOrWebNews();
    },
    async searchNews(word) {
      if (!word) {
        return;
      }
      const params = {
        sort: "title",
        direction: "asc",
        page: 1,
        limit: 10,
        principal_id: this.currentPrincipal,
        query: word
      };
      try {
        await this.$store.dispatch("getAutocompleteNews", params);
      } catch (err) {
        this.$emit("createError", err);
      }
    },
    "editedItem.feature_ids": function() {
      if (this.isPrintNews)
        this.editedItem.print_category_sort =
          this.getCategoryForPrintNews(this.editedItem)?.sort || 0;
    },
    "editedItem.issue_id": function(newValue) {
      this.editedItem.issue_sort =
        this.getIssueById(newValue)?.release_date || 0;
    },
    "editedItem.appdinx_duplicate_content_type_id": function() {
      this.$set(this.editedItem, "appdinx_channels", []);
      if (this.appChannels.length === 1) {
        this.$set(this.editedItem, "appdinx_channels", this.appChannelIds);
      }
    }
  },
  props: ["dialog", "config"],
  computed: {
    showPreview() {
      return (
        !this.editedItem?.meta_data?.externLinkNews &&
        this.newsApiKey?.apiKey?.length
      );
    },
    contentTypes() {
      if (this.editedItem?.contentTypes?.length) {
        return this.editedItem.contentTypes;
      }

      const principal = this.$store.state.principals.find(
        p => p.id === this.currentPrincipal
      );

      if (principal?.newsContentTypes?.length) {
        return principal.newsContentTypes;
      }

      return getDefaultContentTypes(this.editedItem.images ?? []);
    },
    newsEditor() {
      return this.$store.state.currentUser?.scopes.includes("role:news_editor");
    },
    newsAdmin() {
      return this.$store.state.currentUser?.scopes.includes("role:news_admin");
    },
    setNewsDefaultDate() {
      return !!this.config.setNewsDefaultDate;
    },
    channels() {
      const activeOwnChannels = this.config.own_channels.filter(channel =>
        this.config.channels.includes(channel.value)
      );
      const activeStandardChannels = this.config.standard_channels.filter(
        channel => this.config.channels.includes(channel.value)
      );
      return activeStandardChannels.concat(activeOwnChannels);
    },
    selectedOwnChannels() {
      return this.config.own_channels.filter(channel =>
        this.editedItem.channels.includes(channel.value)
      );
    },
    users() {
      return this.$store.state.users;
    },
    newsMediaChannels() {
      return this.channels
        .filter(channel => channel.value !== "app")
        .map(channel => {
          const copy = Object.assign({}, channel);
          if (copy.value === "web") {
            copy.title = "Web/App";
          }
          return copy;
        });
    },
    webContentConfig() {
      return {
        ...this?.$editorConfig,
        height: 400
      };
    },
    formTitle() {
      if (this.isLocked(this.editedItem)) return "";
      return this.editedItem.isNew
        ? "Nachricht anlegen"
        : "Nachricht bearbeiten";
    },
    principals() {
      return this.$store.state.principals ?? [{}];
    },
    currentPrincipal() {
      return this.$store.state.selectedPrincipal.id;
    },
    newsApiKey() {
      const defaultApiKey =
        this.$store.state.selectedPrincipal.modulePreviewApiKeys?.news ||
        undefined;

      if (!defaultApiKey) return this.config?.apiKeys?.[0] ?? {};

      return this.config?.apiKeys?.find(key => key.apiKey === defaultApiKey);
    },
    appdinxLogin() {
      return this.$store.state.selectedPrincipal?.additional_data?.appdinxLogin;
    },
    isAdmin() {
      return this.$store.state.currentUser?.scopes.includes("role:admin");
    },
    userCanSendPushMessages() {
      return this.$store.state.currentUser?.scopes.includes(
        "role:news_app_push_messages"
      );
    },
    showPushMessagePanel() {
      if (!this.isAppNews) {
        return false;
      }
      return this.isAdmin || this.userCanSendPushMessages;
    },
    isEligibleNewsToCreatePushMessageFor() {
      if (this.existingAppPushMessage) {
        return false;
      }
      if (!this.isAppNews) {
        return false;
      }
      if (!this.editedItem._id || this.editedItem.isNew) {
        return false;
      }
      if (this.editedItem.deleted === true) {
        return false;
      }
      if (!this.editedItem.released) {
        return false;
      }
      if (!this.editedItem.appdinx_article_id) {
        return false;
      }
      if (!this.editedItem.appdinx_duplicate_content_type_id) {
        return false;
      }
      if (!this.editedItem.appdinx_channels?.length) {
        return false;
      }
      if (this.editedItem.web_expire_date?.length) {
        const expireDate = new Date(this.editedItem.web_expire_date);
        if (expireDate < new Date()) {
          return false;
        }
      }
      return true;
    },
    isPrintNews() {
      return this.editedItem?.channels?.includes("gemeindeblatt");
    },
    isWebNews() {
      const webOrOwnChannels = this.editedItem?.channels?.filter(
        channel => channel !== "app" && channel !== "gemeindeblatt"
      );

      return !!this.editedItem?.channels?.find(channel =>
        webOrOwnChannels?.includes(channel)
      );
    },
    isAppNews() {
      return this.editedItem?.channels?.includes("app");
    },
    appContentType() {
      return this.appContentTypes?.find(
        contentType =>
          contentType.appdinx_id ===
          this.editedItem.appdinx_duplicate_content_type_id
      );
    },
    appChannels() {
      if (!this.appContentType) {
        return [];
      }
      return this.features.filter(feature =>
        this.appContentType.feature_ids.includes(feature._id)
      );
    },
    appChannelIds() {
      return this.appChannels.map(channel => channel.appdinx_channel_id);
    },
    isPrintOverwritten() {
      return (
        this.isPrintNews &&
        this.editedItem.alternative_content.gemeindeblatt.length > 0
      );
    },
    isWebOverwritten() {
      return (
        (this.isWebNews || this.isAppNews) &&
        this.editedItem.alternative_content.web.length > 0
      );
    },
    appChannelsInvalid() {
      return (
        this.isAppNews &&
        !this.editedItem.appdinx_channels?.some(channel => !!channel)
      );
    },
    releaseAfterExpireDate() {
      if (this.editedItem.web_release_date && this.editedItem.web_expire_date)
        return (
          new Date(this.editedItem.web_release_date) >
          new Date(this.editedItem.web_expire_date)
        );
      return false;
    },
    autocompleteNews() {
      return this.$store.state.autocompleteNews;
    },
    relatedNews() {
      return this.$store.state.relatedNews;
    },
    cIssues() {
      return this.issues.map(item => {
        if (item.closed) {
          if (!item.title.includes("(geschlossen)")) {
            item.title += " (geschlossen)";
          }
          item.disabled = true;
        }
        return item;
      });
    },
    cFilledFeatureGroups() {
      if (!Array.isArray(this.featureGroups)) return [];
      return this.featureGroups?.filter(item => {
        return (
          item.features.length &&
          item.channels.some(featureGroupChannel =>
            this.editedItem.channels.includes(featureGroupChannel)
          )
        );
      });
    },
    newsLinks: {
      get() {
        if (
          !Array.isArray(this.editedItem.news_links) ||
          this.editedItem.news_links.length === 0
        ) {
          this.editedItem.news_links = [{ title: "", url: "" }];
        }
        return this.editedItem.news_links;
      },
      set(value) {
        this.editedItem.news_links = value;
        this.$forceUpdate();
      }
    },
    activeImports() {
      return imports
        .filter(_ => _.isActive(this.$store.state.selectedPrincipal))
        .map(_ => _.typeId);
    },
    importedFrom() {
      if (!this.editedItem.additionalData?.length) {
        return;
      }

      const importedFrom = this.activeImports.filter(systemId =>
        this.editedItem.additionalData.find(d => d.typeId === systemId)
      );
      return importedFrom;
    },
    importedFromString() {
      if (!this.importedFrom?.length) {
        return;
      }

      return `${this.importedFrom
        .map(str => str.replace("-ID", ""))
        .join(", ")}-Import`;
    },
    thirdPartySystems() {
      const typeIds = this.importedFrom;
      return this.getThirdPartySystem(typeIds, "News");
    },
    isOwnedBySubPrincipal() {
      return this.editedItem.principal_id !== this.currentPrincipal;
    }
  },
  methods: {
    moment() {
      return moment;
    },
    ...newsHelperVar,
    ...newsGbXmlHelper,
    isLocked,
    getIssueById,
    getThirdPartySystem,
    generateImageFromPdf,
    triggerDialog({ save, contentTypes, close }) {
      if (save && contentTypes?.length) {
        this.editedItem.contentTypes = contentTypes;
      }

      if (close) {
        this.customizeDialog = !this.customizeDialog;
        this.refreshKey++;
      }
    },
    cleanupContentTypes(contentTypes) {
      return contentTypes.map(contentType => {
        const { selectedImages, ...rest } = contentType;

        if (!selectedImages?.length && !contentType.type.includes("images")) {
          return rest;
        }

        let availableImages = selectedImages?.filter(sImage =>
          this.editedItem.images.find(i => i.url === sImage.url)
        );

        if (availableImages?.length) {
          return {
            selectedImages: availableImages,
            ...rest
          };
        }

        // if no images are available, return empty array, only for images2
        if (!selectedImages?.length && contentType.type === "images2") {
          return {
            selectedImages: [],
            ...rest
          };
        }

        let fallbackImages = this.editedItem.images ?? [];

        rest.selectedImages = fallbackImages;
        rest.orderedImages = fallbackImages;
        return rest;
      });
    },
    panelDisplay(key) {
      return this.hidePanels.includes(key) ? "d-none" : "";
    },
    async getLogs() {
      const headers = getTokenHeader();
      const response = await axios.get(
        `${env.news_api_client_url}logs/${this.editedItem._id}`,
        { headers }
      );
      this.logs = response?.data || [];
      if (!this.logs?.length)
        await this.$store.dispatch("createError", {
          text: "Keine Logs gefunden..."
        });
    },
    setViewLog(index) {
      if (!this.viewLog.includes(index)) {
        this.viewLog.splice(0, 1);
        this.viewLog.push(index);
      } else this.viewLog.splice(0, 1);
    },
    getUserName(user) {
      const foundUser = this.users.find(item => item._id === user);
      return `${foundUser.first_name} ${foundUser.last_name}`;
    },
    formDate(date) {
      return moment(date)
        .locale("de")
        .format("DD.MM.YY HH:mm");
    },
    getChannelTitle(value) {
      if (value) {
        return this.channels?.find(channel => channel.value.includes(value))
          ?.title;
      }
      return value;
    },
    addNewsLink() {
      this.newsLinks.push({ title: "", url: "" });
    },
    removeNewsLink(index) {
      const remove = this.newsLinks;
      remove.splice(index, 1);
      this.newsLinks = remove;
    },
    move(array, element, delta) {
      let index = array.indexOf(element); //find element to move
      let newIndex = index + delta; //calculate destination-index
      if (newIndex < 0 || newIndex === array.length) return; //Already at the top or bottom.
      let indexes = [index, newIndex].sort(); //Sort the indexes
      const moveNewsLinks = this.newsLinks;
      moveNewsLinks.splice(indexes[0], 2, array[indexes[1]], array[indexes[0]]); //Replace from lowest index, two elements, reverting the order
      this.newsLinks = moveNewsLinks;
    },
    async createError(error) {
      this.$store.dispatch("createError", error);
    },
    async createSuccess(successMessage) {
      this.$store.dispatch("createSuccess", successMessage);
    },
    async triggerPreview() {
      const confirmRes = await this.$confirm(
        `Möchten Sie Änderungen speichern?`,
        confirmWarningConfig
      );
      if (confirmRes) {
        await this.save(false);
        this.previewDialog = true;
        // reload iframe to refresh news preview, 1 sec delay needed
        const foundElement = document.getElementById("news_dv_iframe");
        if (foundElement) document.getElementById("news_dv_iframe").src += "";
      }
    },
    fillData(data) {
      this.editedItem = data.editedItem;
      if (!this.editedItem.channels) {
        this.editedItem.channels = [];
      }
      this.issues = data.issues;
      this.features = data.features;
      this.featureGroups = data.featureGroups;
      this.appContentTypes = data.appContentTypes;
      this.createMissingProperties();
      // file + imagepreview uses id before upload and _id after upload
      this.editedItem.images = this?.editedItem?.images?.map(file => {
        file.id = file._id;
        return file;
      });
      this.editedItem.files = this?.editedItem?.files?.map(file => {
        file.id = file._id;
        return file;
      });

      if (this.editedItem.related_news.length > 0) {
        this.refreshRelatedNews();
      }
      if (this.editedItem.creator_id) {
        getUserById(this.editedItem.creator_id).then(creator => {
          this.creator = creator;
        });
      }
      if (this.setNewsDefaultDate && !this.editedItem._id)
        this.editedItem.newsDate = new Date().toISOString();
      if (this.config.expireInDays)
        this.editedItem.web_expire_date = moment(new Date())
          .add(this.config.expireInDays, "days")
          .toISOString();
      this.unsaved = JSON.stringify(this.editedItem, null, 2);
    },
    loadingStatus(status) {
      this.loading = status;
    },
    close() {
      if (!this.editedItem._id && !this.editedItem.isNew) {
        this.$emit("close");
        return;
      }
      this.$confirm(
        `Wollen Sie wirklich Abbrechen? Alle Änderungen werden verworfen!`,
        confirmWarningConfig
      ).then(res => {
        if (res) {
          this.logs = [];
          this.viewLog = [];
          this.$emit("close");
        }
      });
    },
    getParamsForIframeSrc(colorObj) {
      let c = "?";
      const paramsObj = {
        apiKey: this.newsApiKey?.apiKey,
        ...colorObj
      };
      let params = "";
      for (const [key, value] of Object.entries(paramsObj)) {
        params += `${c}${key}=${encodeURIComponent(value)}`;
        c = "&";
      }
      return params;
    },
    getIframeSrc() {
      const slug = this.editedItem.meta_data.url_part || this.editedItem._id;
      return `${
        env.news_widget_api_url
      }news/detail/${slug}${this.getParamsForIframeSrc(
        this.newsApiKey?.color
      )}`;
    },
    getIframeHTML() {
      return `<iframe id="news_dv_iframe" style="width: 100%; height: 100vh" src="${this.getIframeSrc()}"></iframe>`;
    },
    setPanelsForAppOrWebNews() {
      const hiddenPanels = [];
      if (!this.isAppNews && !this.isWebNews) {
        hiddenPanels.push(5);
        hiddenPanels.push(3);
      }
      if (!this.showPushMessagePanel) {
        hiddenPanels.push(4);
      }
      this.hidePanels = [...hiddenPanels];

      if (this.hidePanels.includes(this.panel)) {
        this.panel = undefined;
      }
    },
    // All panels must be open to validate the form. Small delay needed for it to be effective.
    async openAllPanelsForValidation() {
      return new Promise(resolve => {
        const panels = this.panels
          .filter(panel => !this.hidePanels.includes(panel.key))
          .map(panel => panel.key);
        this.panel = panels;
        setTimeout(resolve, 1);
      });
    },
    debounceSave: _.debounce(async function(close) {
      await this.save(close);
    }, 500),
    async save(close) {
      const panel = this.panel;
      await this.openAllPanelsForValidation();
      const isValid = this.$refs.editForm.validate();
      this.panel = panel;
      if (!isValid) {
        this.errorList = [];
        const form = this.$refs.editForm;
        const invalidFields = form._data.inputs.filter(i => !i.valid);
        this.errorList = [];
        invalidFields.forEach(field => {
          this.errorList.push({
            field: field?.$vnode?.componentOptions?.propsData?.label?.replace(
              "*",
              ""
            ),
            validations: field.validations
          });
        });
        if (this.errorList.length) {
          this.errorDialog = true;
        }
        this.loadingStatus(false);
        return;
      }

      let success = false;
      this.loadingStatus(true);
      try {
        await this.saveImages();
        await this.saveFiles();
        await this.removeFiles();
        if (this.editedItem?.contentTypes?.length) {
          this.editedItem.contentTypes = this.cleanupContentTypes(
            this.editedItem.contentTypes
          );
        }
        if (!this.editedItem?.contentTypes?.length) {
          const contentTypes = this.contentTypes?.length
            ? this.contentTypes
            : getDefaultContentTypes(this.editedItem.images ?? []);
          this.editedItem.contentTypes = contentTypes;
        }

        success = this.editedItem.isNew
          ? await this.createNews()
          : await this.updateNews();
        if (success) {
          this.unsaved = JSON.stringify(this.editedItem, null, 2);
          this.$emit("afterSave", close);
        }
      } catch (ex) {
        //catch invalid token. open login-dialog
        if (ex.toString().includes("401")) {
          this.needLogin = true;
          this.loadingStatus(false);
          return;
        }
        if (ex.response?.data?.toString().includes("issue_deadline_fail")) {
          this.createError({
            ...ex,
            text:
              "Ausgabe bereits geschlossen!\nBitte wählen sie eine andere Ausgabe.\n"
          });
          await this.loadIssues();
          this.loadingStatus(false);
          return;
        }

        this.createError(ex);
      }
      this.loadingStatus(false);
      return success;
    },
    async openCreatePushMessageEditDialog() {
      const saveConfirm = await this.$confirm(
        "Zum Anlegen einer Push-Nachricht muss die Nachricht gespeichert werden.<br/><br/>Nachricht speichern und fortfahren?",
        {
          buttonFalseText: "Abbrechen",
          buttonTrueText: "Speichern"
        }
      );
      if (!saveConfirm) {
        return;
      }

      try {
        const saveSuccess = await this.save(false);
        if (!saveSuccess) {
          return;
        }
      } catch (e) {
        return;
      }

      if (!this.isEligibleNewsToCreatePushMessageFor) {
        await this.createError({
          text:
            "Die Nachricht erfüllt nicht (mehr) die Bedingungen zum Anlegen einer Push-Nachricht. Bitte überprüfen Sie Ihre Eingaben."
        });
        return;
      }

      this.createAppPushMessageDialog = true;
    },
    afterCreateAppPushMessage(data) {
      this.createAppPushMessageDialog = false;
      if (!(data instanceof Event)) {
        this.existingAppPushMessage = data;
      }
    },
    getCleanedUpLockedNews() {
      const {
        _id,
        relatedNews,
        additionalData,
        channels,
        alternative_content,
        meta_data,
        newsDate,
        news_links,
        principal_id,
        related_news,
        web_release_date,
        web_expire_date
      } = this.editedItem;

      return {
        _id,
        relatedNews,
        additionalData,
        channels,
        alternative_content,
        related_news,
        meta_data,
        newsDate,
        news_links,
        principal_id,
        web_expire_date,
        web_release_date,
        onlyUpdateWebData: true
      };
    },

    async updateNews() {
      delete this.editedItem.create_date;
      let item = this.editedItem;
      if (this.isLocked(this.editedItem)) {
        item = this.getCleanedUpLockedNews();
        if (!item.channels?.includes("gemeindeblatt"))
          item.channels.push("gemeindeblatt");
      }
      const headers = getTokenHeader(),
        res = await axios.put(`${env.news_api_client_url}news`, item, {
          headers
        });
      this.editedItem = res.data;
      this.editedItem.meta_data.url_part = res.data?.meta_data?.url_part;
      this.editedItem.appdinx_article_id = res.data?.appdinx_article_id;
      return res.status === 200;
    },
    async newsPut(data) {
      if (this.editedItem.isNew) {
        this.createError({
          text: "Nachricht muss angelegt sein."
        });
        return;
      }
      const headers = getTokenHeader(),
        res = await axios.put(`${env.news_api_client_url}news`, data, {
          headers
        });
      this.editedItem.meta_data.url_part = res.data?.meta_data?.url_part;
      return res.status === 200;
    },
    async saveWebDates() {
      return await this.newsPut(
        // webservice only keeps _id,principal_id,web_release_date,web_expire_date and web_archive_date
        { ...this.editedItem, onlyUpdateWebDates: true }
      );
    },
    async saveMetaInfos() {
      return await this.newsPut(
        // webservice only keeps _id,principal_id,related_news and meta_data
        { ...this.editedItem, onlyUpdateMetaInfos: true }
      );
    },
    async createNews() {
      const headers = getTokenHeader(),
        res = await axios.post(
          `${env.news_api_client_url}news`,
          this.editedItem,
          { headers }
        );
      this.editedItem.isNew = false;
      this.editedItem._id = res.data._id;
      this.editedItem.meta_data.url_part = res.data?.meta_data?.url_part;
      this.editedItem.web_expire_date = res.data?.web_expire_date;
      this.editedItem.appdinx_article_id = res.data?.appdinx_article_id;
      return res.status === 200;
    },
    createMissingProperties() {
      if (!this.editedItem.alternative_content) {
        this.editedItem.alternative_content = {
          web: "",
          gemeindeblatt: ""
        };
      }
      if (!this.editedItem.alternative_content_2) {
        this.editedItem.alternative_content_2 = {
          web: ""
        };
      }
      if (!this.editedItem.alternative_content_3) {
        this.editedItem.alternative_content_3 = {
          web: ""
        };
      }
    },
    editCustomization() {
      this.customizeDialog = true;
      this.refreshKey++;
    },
    async debugGbXml() {
      if (this.debugXml) {
        if (!this?.editedItem?.issue_id) {
          console.info("debugGbXml: keine ausgabe gewählt!");
          return;
        }
        await this.loadIssues();
        await this.loadFeatures();
        await this.loadFeatureGroups();

        let xml = await this.buildIssueXml([this.editedItem]);
        console.info("xml", xml);
      }
    },
    //remove or add publication-channel
    toggleChannel(channelValue) {
      if (this.editedItem.channels.includes(channelValue)) {
        this.editedItem.channels = this.editedItem.channels.filter(item => {
          return item?.length && item !== channelValue;
        });
        this.editedItem.channels.reverse().reverse();
      } else {
        this.editedItem.channels.push(channelValue);
      }

      if (!this.editedItem.alternative_content_2)
        this.editedItem.alternative_content_2 = { web: "" };
      if (!this.editedItem.alternative_content_2[channelValue])
        this.editedItem.alternative_content_2[channelValue] = "";
      if (!this.editedItem.alternative_content_3)
        this.editedItem.alternative_content_3 = { web: "" };
      if (!this.editedItem.alternative_content_3[channelValue])
        this.editedItem.alternative_content_3[channelValue] = "";
    },
    async addDropImage(e) {
      if (!Array.isArray(this.editedItem.images)) this.editedItem.images = [];
      const files = e?.dataTransfer?.files ?? e ?? [];
      await Array.from(files).asyncForEach(async file => {
        file.id = uuid();
        const fileData = await this.readFileUrl(file);
        file.channels = this.editedItem.channels.filter(
          c => c?.length && c !== "app"
        );
        file.originalUrl = fileData;
        file.dataUrl = fileData;
        file.title = "";
        file.original_name = file.name;
        if (this.acceptImageMimeType.includes(file.type) && file.type) {
          this.editedItem.images.push({ newFile: file });
          await this.saveImages();
        } else {
          this.createError({
            text:
              "Datei '" +
              file.name +
              "' kann nicht als Bild hochgeladen werden."
          });
        }
      });
      await this.save(false);
      this.refreshKey++;
    },
    async addDropFile(e) {
      if (!Array.isArray(this.editedItem.files)) this.editedItem.files = [];
      const files = e?.dataTransfer?.files ?? e ?? [];
      await Array.from(files).asyncForEach(async file => {
        file.id = uuid();
        const fileData = await this.readFileUrl(file);
        file.originalUrl = fileData;
        file.dataUrl = fileData;
        file.title = file.name;
        file.original_name = file.name;
        file.channels = this.editedItem.channels.filter(c => c !== "app");
        this.editedItem.files.push(file);
      });
    },
    readFileUrl(file) {
      return new Promise((resolve, reject) => {
        if (file) {
          const reader = new FileReader();
          reader.onload = ({ target }) => {
            if (target?.result) resolve(target.result);
            else reject("Unable to read File");
          };
          reader.readAsDataURL(file);
        } else reject("No file passed");
      });
    },
    async removeImage(id) {
      // TODO: Remove File from S3
      const index = this.editedItem.images.findIndex(f => f.id === id);
      if (
        await this.$confirm(
          `Wollen Sie die Datei "${this.editedItem.images[index].original_name}" wirklich löschen?`,
          confirmWarningConfig
        )
      ) {
        // remember files to delete for save-process
        this.removeFileArray.push(
          Object.assign({}, this.editedItem.images[index])
        );
        this.editedItem.images.splice(index, 1);
        this.refreshKey++;
      }
    },
    async removeFile(id) {
      // TODO: Remove File from S3
      const index = this.editedItem.files.findIndex(f => f.id === id);
      if (
        await this.$confirm(
          `Wollen Sie die Datei "${this.editedItem.files[index].title}" wirklich löschen?`,
          confirmWarningConfig
        )
      ) {
        // remember files to delete for save-process
        this.removeFileArray.push(
          Object.assign({}, this.editedItem.files[index])
        );
        this.editedItem.files.splice(index, 1);
      }
    },
    async saveImages() {
      const files = this.editedItem.images;

      const pictures = [];
      await files.asyncForEach(async file => {
        if (file.imageSizes) {
          file.image_sizes = file.imageSizes;
        }
        if (!file.url) {
          //convert base64-data-url to blob
          const res = await fetch(file.newFile.dataUrl);
          const blob = await res.blob();
          blob.filename = file.newFile.name;
          const newFile = await uploadFile(
            blob,
            this.editedItem.id || this.editedItem._id,
            "news",
            progressEvent => {
              this.createSuccess(
                Math.round((progressEvent.loaded * 100) / progressEvent.total) +
                  " % hochgeladen.."
              );
            }
          );
          //add file properties
          file = { ...newFile, ...file.newFile };
          delete file.originalUrl;
          delete file.dataUrl;
          file.id = file.id ?? file._id;
        } else if (file.url && this.editedItem.isNew) {
          //copy image for cloned news
          await this.copyFile(file);
        }

        if (!file.image_sizes && file.url) {
          file.image_sizes = await getImageDimensionSizes(file.url);
        }

        pictures.push(file);
      });
      this.editedItem.images = pictures;
      this.editedItem.images.reverse().reverse();
    },
    async saveFiles() {
      const files = this.editedItem.files;

      const fileArray = [];
      await files.asyncForEach(async file => {
        if (!file.url) {
          const isPdfFile = file.type.toLowerCase() === "application/pdf";
          const newFile = await uploadFile(
            file,
            this.editedItem.id || this.editedItem._id,
            "news",
            progressEvent => {
              this.createSuccess(
                Math.round((progressEvent.loaded * 100) / progressEvent.total) +
                  " % hochgeladen.."
              );
            }
          );

          if (isPdfFile) {
            const generatedPdfPicture = await this.generateImageFromPdf(
              newFile.url,
              newFile.title.replace(".pdf", "")
            );
            newFile.picture = await uploadFile(
              generatedPdfPicture,
              this.editedItem.id || this.editedItem._id,
              "news",
              progressEvent => {
                this.$store.dispatch(
                  "createSuccess",
                  Math.round(
                    (progressEvent.loaded * 100) / progressEvent.total
                  ) + " % Bild aus PDF generiert ..."
                );
              }
            );
          }

          //add file properties
          file = { ...newFile, ...file };

          delete file.originalUrl;
          delete file.dataUrl;
          file.id = file.id ?? file._id;
        } else if (file.url && this.editedItem.isNew) {
          //copy file for cloned news
          await this.copyFile(file);
        }
        fileArray.push(file);
      });
      this.editedItem.files = fileArray;
      this.editedItem.files.reverse().reverse();
    },
    async removeFiles() {
      await this.removeFileArray.asyncForEach(async (file, index, object) => {
        if (file.url) await destroyFile("news", getMongoFileId(file));
        object.splice(index, 1);
      });
    },
    sortImages(newVal) {
      const order = newVal.map(v => v.id);
      this.editedItem.images = _.sortBy(this.editedItem.images, file => {
        return _.indexOf(order, file.id);
      });
    },
    sortFiles(newVal) {
      const order = newVal.map(v => v.id);
      this.editedItem.files = _.sortBy(this.editedItem.files, file => {
        return _.indexOf(order, file.id);
      });
    },
    async refreshRelatedNews() {
      try {
        await this.$store.dispatch(
          "getRelatedNews",
          this.editedItem.related_news
        );
      } catch (err) {
        this.$emit("createError", err);
      }
    },
    confirmUnrelease(released) {
      // release-value already changed
      // changeback if unrelease not confirmed
      if (!released) {
        this.$confirm(
          "Freigabe für " + this.editedItem.title + " wirklich zurücknehmen?",
          confirmWarningConfig
        ).then(yes => {
          if (!yes) {
            this.editedItem.released = true;
          }
        });
      }
    },
    async copyFile(file) {
      const fileId = getMongoFileId(file);
      try {
        const headers = getTokenHeader();
        const res = await axios.post(
          `${env.file_client_url}v1/file/copy`,
          {
            id: fileId
          },
          { headers }
        );
        const newFile = {
          id: res.data?.data?._doc?._id,
          url: res.data?.url
        };
        file.url = newFile.url;
        let sizes = file.image_sizes;
        if (sizes) {
          Object.keys(sizes).forEach(key => {
            sizes[key].url = sizes[key].url.replace(fileId, newFile.id);
          });
        }
      } catch (err) {
        this.$emit("createError", err);
      }
    },
    isAppFeature(feature) {
      return !!feature.appdinx_channel_id;
    },
    isRequiredFeatureGroupFulfilled(featureGroup) {
      if (!featureGroup.isRequired) {
        return true;
      }
      return featureGroup.features.some(feature =>
        this.editedItem.feature_ids.includes(feature._id)
      );
    }
  }
};
